import {
  Mutation, MutationAction, Action, VuexModule, getModule, Module,
} from 'vuex-module-decorators';
import store from '../index';
import { SystemService } from '../../api/system-service';

// ステート インターフェース
export interface IAuthState {
  loggedIn: boolean;
}

@Module({
  dynamic: true, store, name: 'auth-state', namespaced: true,
})
class AuthState extends VuexModule implements IAuthState {
    // state
    loggedIn: boolean = false;

    // mutation
    @Mutation
    SET_LOGGED_IN(loggedIn: boolean): void {
      this.loggedIn = loggedIn;
    }

    @Action
    login() {
      this.SET_LOGGED_IN(true);
    }

    @Action
    logout() {
      this.SET_LOGGED_IN(false);
    }
}

export const authState: AuthState = getModule(AuthState);
